// extracted by mini-css-extract-plugin
export default {"body2":"Body2_body2__2A99A","body2-semi-bold":"Body2_body2-semi-bold__4f0nQ"};